import { createContext } from 'react';

import { FormContextType } from '../@types';

const PaymentCardFormContext = createContext<FormContextType | null>(null);

export { PaymentCardFormContext };
